import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Trades() {
  return <ImageCollectionPage title="Trades" path="/culture/trades" collection="culture_trades" />;
}
